import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import VenueBlockedDatesCreateEditForm from './Components/VenueBlockedDatesCreateEditForm';
import VenueBlockedDatesApi from './VenueBlockedDatesApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: VenueBlockedDatesCreateEditForm,
                getCreate: VenueBlockedDatesApi.create,
                getClone: VenueBlockedDatesApi.getOne,
                defaults: {},
                successMessage: "VenueBlockedDates Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}